import Marquee from "react-fast-marquee";

const WORDS = [
  "Provider Enrollment",
  "Credentialing",
  "Payer Contracting",
  "CAQH Management",
  "Medicare & Medicaid",
  "Revalidation",
  "Roster Maintenance",
];

export default function EditorialMarquee() {
  return (
    <section data-testid="marquee-section" className="py-14 md:py-20 border-y border-border bg-secondary overflow-hidden">
      <Marquee speed={38} gradient={false} autoFill>
        {WORDS.map((w, i) => (
          <div key={i} className="flex items-center">
            <span className="font-serif font-light text-4xl md:text-6xl tracking-tight text-secondary-foreground px-8">{w}</span>
            <span className="h-2 w-2 rounded-full bg-primary/40" />
          </div>
        ))}
      </Marquee>
    </section>
  );
}
